import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import Modal from '../../components/Modal';
import Header from '../../components/Header';
import Progress from '../../components/Progress';
import ApplicationId from '../../components/ApplicationId';
import imgDeclined from '../../assets/images/declined.svg';
import { addLusaHeaderParam, parseUrlParams } from '../../utils/parseUrlParams';
import { resumeApplication as resumeApplicationAction } from '../../actions/navigation';
import imgError from '../../assets/images/error.svg';
import { ricWorkflowName } from '../../utils/appConstants';

export const CreditFreeze = ({ checkinData }) => {
  const match = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errorMsg, setErrorMsg] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');
  const ricWorkFlow = workflowType === ricWorkflowName;

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (!get(checkinData, 'data.data') && !get(checkinData, 'state.data')) {
      let routeUrl = `/${workflowType === 'dtm-luwa' ? 'luwa' : workflowType}/?key=${params.key}`;
      if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
        routeUrl = addLusaHeaderParam(routeUrl);
      }
      navigate(routeUrl);
    }
  }, [checkinData]);

  const resumeApplication = () => {
    const params = parseUrlParams(window.location.search);
    setIsProgressVisible(true);
    dispatch(resumeApplicationAction({
      key: get(checkinData, 'data.data.continueApplicationKey') || get(checkinData, 'state.data.continueApplicationKey'),
      activity: 'continuefromcreditfreeze',
      workflowType,
      success: (res) => {
        setIsProgressVisible(false);
        let route = get(res, 'state.url', '') || get(res, 'data.url', '');
        if (route && params.lusa_header && params.lusa_header === 'false') {
          route = addLusaHeaderParam(route);
        }
        if (route) {
          navigate(route);
        }
      },
      fail: (error) => {
        setIsProgressVisible(false);
        setIsPopupVisible(true);
        if (error?.response?.data && error.response.data.errorMessages && error?.response?.data.errorMessages.length > 0) {
          setErrorMsg(error.response.data.errorMessages[0]);
        }
        console.log('error', error);
      },
      onUploadProgress: (progressEvent) => {
        setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
      },
    }));
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
    setErrorMsg('');
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header navigate={navigate} />
      {get(checkinData, 'attributes.entityId', get(checkinData, 'entityId')) ? (
        <ApplicationId id={get(checkinData, 'attributes.entityId', get(checkinData, 'entityId'))} style={{ marginTop: 10 }} />
      ) : null}
      <div className="content" style={{ minHeight: 'calc(100vh - 205px)' }}>
        <img src={imgDeclined} alt="Declined" width="100px" />
        <h1>Your Credit Is Frozen</h1>
        <p style={{ marginBottom: 0 }}>The following actions are needed so that a decision can be made on your application:</p>
        <b style={{ fontWeight: 'bold' }}>
          To remove the freeze from your credit report, please visit the
          {' '}
          <a target="_blank" rel="noopener noreferrer" href="https://service.transunion.com/dss/login.page?">TransUnion Service Center</a>
          {' '}
          or call TransUnion at
          {' '}
          <a href="tel:+18889098872">888-909-8872</a>
          .
        </b>
        <b style={{ fontWeight: 'bold' }}>
          After the removal of the credit freeze, please click on this
          {' '}
          {/* eslint-disable-next-line */}
          <a href="#" onClick={resumeApplication}>link</a>
          {' '}
          to continue your application.
        </b>
        <hr />
        <p>
          You must complete the above actions within 30 days; otherwise, we will be unable to proceed with this
          {!ricWorkFlow && 'credit'}
          {' '}
          application.
        </p>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <a href="tel:+18009946177" className="btn">Contact Us</a>
          </div>
        </div>
      </div>
      {
        isPopupVisible && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="" />
              <p>{errorMsg || 'Please try again.'}</p>
              <div onClick={handleClosePopup} className="btn btn-red">OK</div>
            </div>
          </Modal>
        )
      }
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

CreditFreeze.propTypes = {
  checkinData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

export default connect(mapStateToProps)(CreditFreeze);
